import { remove } from 'lodash';
/**
 * @deprecated BaseCollection is deprecated and has to be removed withing
 * https://doxyme.atlassian.net/browse/CS-8573
 */
export class BaseCollection {
    constructor(models = []) {
        this.models = models;
        this.proxyModelsMethods();
    }
    get length() {
        return this.models.length;
    }
    set length(value) {
        this.models.length = value;
    }
    add(model) {
        if (!Boolean(model)) {
            return;
        }
        if (this.models.includes(model)) {
            return;
        }
        this.models.push(model);
    }
    remove(model) {
        if (!Boolean(model)) {
            return;
        }
        remove(this.models, (m) => m === model);
    }
    clear() {
        this.models.length = 0;
    }
    find(predicate) {
        return this.models.filter((item) => predicate(item));
    }
    findOne(predicate) {
        return this.models.find((item) => predicate(item));
    }
    /**
     * @deprecated Do not use those proxy methods in favor of array methods(models.map, models.filter etc)
     *             That was added to maintain interface throughout the code.
     */
    proxyModelsMethods() {
        const methodsToProxy = [
            'map',
            'filter',
            'forEach',
            'sort',
            'includes',
            'some',
        ];
        for (const method of methodsToProxy) {
            this[method] = (cb) => this.models[method](cb);
        }
    }
}
